<template>
  <header class="black-bg mh-header mh-fixed-nav nav-scroll mh-xs-mobile-nav" id="mh-header">
    <div
      class="overlay"
      :class="{ active: isActive }"
      @click="isActive = isActive == false ? true : false"
    ></div>
    <div class="container">
      <div class="row">
        <nav class="navbar navbar-expand-lg mh-nav nav-btn">
          <button
            class="navbar-toggler"
            :class="{ active: isActive, collapsed: isActive }"
            type="button"
            data-toggle="collapse"
            @click="isActive = isActive == false ? true : false"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon icon"></span>
          </button>

          <div
            class="collapse navbar-collapse"
            :class="{ active: isActive, show: isActive }"
            id="navbarSupportedContent"
          >
            <ul class="navbar-nav mr-auto ml-auto">
              <li class="nav-item" @click="isActive = false" :class="homeActive">
                <router-link class="nav-link" :to="{ name: 'home', hash: '#home' }">Home</router-link>
              </li>
              <li
                class="nav-item"
                @click="isActive = false"
                :class="[pageHash.includes('about') ? activeClass : '']"
              >
                <router-link class="nav-link" :to="{ name: 'about', hash: '#about' }">About</router-link>
              </li>
              <li
                class="nav-item"
                @click="isActive = false"
                :class="[pageHash.includes('skills') ? activeClass : '']"
              >
                <router-link class="nav-link" :to="{ name: 'skills', hash: '#my-skills' }">Skills</router-link>
              </li>
              <li
                class="nav-item"
                @click="isActive = false"
                :class="[pageHash.includes('experience') ? activeClass : '']"
              >
                <router-link
                  class="nav-link"
                  :to="{ name: 'xp', hash: '#my-experience' }"
                >Experiences</router-link>
              </li>
              <li
                class="nav-item"
                @click="isActive = false"
                :class="[pageHash.includes('services') ? activeClass : '']"
              >
                <router-link
                  class="nav-link"
                  :to="{ name: 'services', hash: '#services-i-render' }"
                >Services</router-link>
              </li>
              <li
                class="nav-item"
                @click="isActive = false"
                :class="[pageHash.includes('portfolio') ? activeClass : '']"
              >
                <router-link
                  class="nav-link"
                  :to="{ name: 'portfolio', hash: '#portfolio-gallery' }"
                >Portfolio</router-link>
              </li>
              <li
                class="nav-item"
                @click="isActive = false"
                :class="[pageHash.includes('contact') ? activeClass : '']"
              >
                <router-link class="nav-link" :to="{ name: 'contact', hash: '#contact' }">Contact</router-link>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  data() {
    return {
      isActive: false,
      activeClass: "active",
      isRoot: false
    };
  },

  computed: {
    currentRoute() {
      return this.$route.path;
    },
    pageHash() {
      return this.$route.hash;
    },
    homeActive() {
      if (this.pageHash.includes("home")) {
        this.isRoot = true;
        return this.activeClass;
      } else if (this.$route.path == "/" && !this.pageHash.includes("home")) {
        this.isRoot = false;
        return "";
      }

      this.isRoot = false;
      return "";
    }
  }
};
</script>

<style scoped>
li.nav-item > a:hover {
  color: #067966 !important;
}
</style>
